// extracted by mini-css-extract-plugin
module.exports = {"tabs":"RadioTabs_tabs__MpcC0","tab":"RadioTabs_tab__1Z9EU","activeTab":"RadioTabs_activeTab__2KfyK RadioTabs_tab__1Z9EU"};